import { render } from "./GaleriaPage.vue?vue&type=template&id=60aa1a8b&scoped=true"
import script from "./GaleriaPage.vue?vue&type=script&lang=js"
export * from "./GaleriaPage.vue?vue&type=script&lang=js"

import "./GaleriaPage.vue?vue&type=style&index=0&id=60aa1a8b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60aa1a8b"]])

export default __exports__